import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./UniversitySubjectCreate.css";

const UniversitySubjectCreate = () => {
  const [subjectName, setSubjectName] = useState("");
  const [universities, setUniversities] = useState([]);
  const [universityId, setUniversityId] = useState("");
  const [courseId, setCourseId] = useState("");
  const [courses, setCourses] = useState([]);
  const [semesterId, setSemesterId] = useState("");
  const [semesters, setSemesters] = useState([]);
  const [subjectUploadIcon, setSubjectUploadIcon] = useState(null);
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

  const [category, setCategory] = useState([]);
  const [selectCategory, setSelectCategory] = useState("");

  const handleAddCategory = () => {
    if (selectCategory && !category.includes(selectCategory)) {
      setCategory([...category, selectCategory]);
      setSelectCategory(""); // reset dropdown
    }
  };

  const handleRemoveCategory = (cat) => {
    setCategory(category.filter((item) => item !== cat));
  };

  useEffect(() => {
    if (universityId) {
      axios
        .get(`${API_BASE_URL}/all-courses/${universityId}`)
        .then((response) => {
          const coursesData = response.data?.data || [];
          setCourses(coursesData);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [universityId]);

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/semesters`)
      .then((response) => {
        const semesterData = response.data?.data || [];
        setSemesters(semesterData);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/universities`)
      .then((response) => {
        const universitiesData = response.data?.data || [];
        setUniversities(universitiesData);
      })
      .catch((error) => console.log(error));
  }, [API_BASE_URL]);

  const handleSubmit = (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("subjectName", subjectName);
    formData.append("semesterId", semesterId);
    formData.append("courseId", courseId);
    if (category.length > 0) {
      category.forEach((cat) => {
        formData.append("category", cat);
      });
    }

    if (subjectUploadIcon) {
      formData.append("icon", subjectUploadIcon); // add file to form data
    }

    axios
      .post(`${API_BASE_URL}/college-subject`, formData, {
        headers: {
          "Content-Type": "multipart/form-data", // Set header for file upload
        },
      })
      .then((response) => {
        console.log("Subject created successfully:", response.data);
        alert("Subject created successfully");
        setSubjectName("");
        setUniversityId("");
        setCourseId("");
        setSemesterId("");
        setSubjectUploadIcon(null); // reset file input
      })
      .catch((error) => {
        console.error("Error creating subject:", error);
        alert("Error creating subject");
      });
  };

  return (
    <>
      <div id="add-college-course-wrapper">
        <div className="course-header-with-btns">
          <h5>Subject</h5>

          <div className="college-course-nav-btns">
            <Link to={"/college-subject"}>
              <button className="college-add-course-add-btn">
                + Add New Subject
              </button>
            </Link>
            <Link to={"/college-all-subject"}>
              <button className="college-all-course-btn">All Subject</button>
            </Link>
          </div>
        </div>

        <div className="add-college-course-inner-main-wrapper">
          <div className="form-main-container">
            <h4 className="college-course-detail">Subject</h4>
            <form
              onSubmit={handleSubmit}
              className="college-course-detail-form"
            >
              <div className="new-chapter-form-group">
                <label className="new-chapter-label">Select University</label>
                <select
                  className="new-chapter-dropdown"
                  value={universityId}
                  onChange={(e) => setUniversityId(e.target.value)}
                  required
                >
                  <option value="">-Select University-</option>
                  {universities.map((universitie, idx) => (
                    <option key={idx} value={universitie._id}>
                      {universitie.universityName}
                    </option>
                  ))}
                </select>
              </div>
              <div className="new-chapter-form-group">
                <label className="new-chapter-label">Course Name</label>
                <select
                  className="new-chapter-dropdown"
                  value={courseId}
                  onChange={(e) => setCourseId(e.target.value)}
                  required
                >
                  <option value="">-Select Course-</option>
                  {courses.map((course, idx) => (
                    <option key={idx} value={course._id}>
                      {course.courseName}
                    </option>
                  ))}
                </select>
              </div>
              <div className="new-chapter-form-group">
                <label className="new-chapter-label">Semester</label>
                <select
                  className="new-chapter-dropdown"
                  value={semesterId}
                  onChange={(e) => setSemesterId(e.target.value)}
                  required
                >
                  <option value="">-Select Semester-</option>
                  {semesters.map((semester, idx) => (
                    <option key={idx} value={semester._id}>
                      {semester.semesterName}
                    </option>
                  ))}
                </select>
              </div>
              <div className="input-group">
                <label className="label">Subject Name</label>
                <input
                  style={{
                    marginLeft: "1px",
                    borderBottomLeftRadius: "5px",
                    borderTopLeftRadius: "5px",
                  }}
                  type="text"
                  value={subjectName}
                  onChange={(e) => setSubjectName(e.target.value)}
                  placeholder="Enter Subject Name..."
                  required
                />
              </div>

              <div className="input-group">
                <div style={{ paddingBottom: "10px" }}>
                  <label className="label">Upload Icon</label>
                </div>
                <input
                  type="file"
                  id="subject-upload-icon"
                  multiple={false}
                  onChange={(e) => {
                    const file = e.target.files[0]; // Access the first file
                    console.log(file);

                    if (file) {
                      setSubjectUploadIcon(file); // Store the file object, not the value
                    }
                  }}
                />
              </div>

              <div className="input-group">
                <div style={{ paddingBottom: "10px" }}>
                  <label className="label">Select Category</label>
                </div>
                <div style={{ display: "flex", gap: "10px" }}>
                  <select
                    className="school-class-add-input-tag"
                    value={selectCategory}
                    onChange={(e) => setSelectCategory(e.target.value)}
                  >
                    <option value="">-Select Category-</option>
                    <option
                      value="Assignment"
                      disabled={category.includes("Assignment")}
                    >
                      Assignment
                    </option>
                    <option
                      value="Subjective_Exam"
                      disabled={category.includes("Subjective_Exam")}
                    >
                      Subjective Exam
                    </option>
                    <option
                      value="Exam_Notes"
                      disabled={category.includes("Exam_Notes")}
                    >
                      Exam Notes
                    </option>
                    <option
                      value="video_section"
                      disabled={category.includes("video_section")}
                    >
                      Video Section
                    </option>
                  </select>
                  <button
                    type="button"
                    onClick={handleAddCategory}
                    className="btn-s"
                  >
                    Add
                  </button>
                </div>
              </div>

              {category.length > 0 && (
                <div className="selected-categories">
                  <p style={{ marginBottom: "5px" }}>Selected Categories:</p>
                  <ul>
                    {category.map((cat, index) => (
                      <li key={index} style={{ marginBottom: "5px" }}>
                        {cat.replaceAll("_", " ")}
                        <button
                          type="button"
                          onClick={() => handleRemoveCategory(cat)}
                          style={{
                            marginLeft: "10px",
                            background: "red",
                            color: "white",
                            border: "none",
                            padding: "2px 6px",
                            borderRadius: "4px",
                            cursor: "pointer",
                          }}
                        >
                          Remove
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              )}

              <div className="college-course-form-btns">
                <button className="btn-search" type="submit">
                  Save
                </button>
                <button className="btn-cancel" type="button">
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default UniversitySubjectCreate;
